import { pick } from 'lodash-es';
import { fetch } from '../utils/request';

const SCREEN_BASE = process.env.TAGBOARD_LIVE_URL;

export default {
  getScreens(owner) {
    return fetch(`${SCREEN_BASE}/screens/${owner}`);
  },

  getScreen(screenId) {
    return fetch(`${SCREEN_BASE}/screen/${screenId}`);
  },

  createScreen(screen) {
    return fetch(`${SCREEN_BASE}/screen/create`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(screen),
    });
  },

  editScreen(screen) {
    return fetch(`${SCREEN_BASE}/screen/${screen._id}`, {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(
        pick(screen, ['title', 'production_id', 'owner']),
      ),
    });
  },

  deleteScreen(screen) {
    return fetch(`${SCREEN_BASE}/screen/${screen._id}`, {
      method: 'DELETE',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        owner: screen.owner,
      }),
    });
  },
};
